import React, { Fragment } from 'react';
import { StepIndicator } from '@components/step-indicator';
import classNames from 'classnames';

import { StepperWrapperProps } from './stepper-wrapper.type';

export const StepperWrapper = ({ steps, currentStep }: StepperWrapperProps) => {
  return (
    <div className='flex items-center gap-1'>
      {steps.map((step, index) => (
        <Fragment key={step.id}>
          <StepIndicator {...step} active={step.slug === currentStep} onClick={step.onClick} />
          {index !== steps.length - 1 && (
            <div
              className={classNames(
                'w-10 h-1 block rounded-full',
                { 'fill-dark': step.completed },
                { 'fill-tertiary-active': !step.completed }
              )}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
};
